import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4c46124"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_2 = { class: "fake-Input gap-2 pt-2 pb-1" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "text-h6"
}

import { withDefaults, ref, computed } from 'vue';
import { IBrandsDetailMeta } from '@/types';
import { AtomInput, AtomInputSearch, SearchStatusIcon, WarehouseIcon, ResealeIcon, CostCenterIcon } from '@/components/atoms';

import { getLanguage } from "@/utils/locale";
import { messages } from "@/utils/i18n";


const __default__ = {
    inheritAttrs: false,
};

interface InputProps {
    label?: string;
    items: IBrandsDetailMeta[],
    type?: 'brand' | 'reseale' | 'warehouse' | 'cost_center'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'AtomInputBrands',
  props: {
    label: {},
    items: {},
    type: {}
  },
  setup(__props: any) {

let locale:string = messages[getLanguage()]['message'];  

const search = ref<string>("");

const props = __props;

const itemsComputed = computed(() => {
    const result = props.items.filter(f => f.name?.toLocaleLowerCase().includes(search.value.toLocaleLowerCase()));
    return result;
})

let placeholder = "";
if (props.type == 'reseale') placeholder = locale['goals_details']['search_resale'];
else if (props.type == 'brand') placeholder = locale['goals_details']['search_brand'];
else if (props.type == 'warehouse') placeholder = locale['goals_details']['search_warehouse'];
else if (props.type == 'cost_center') placeholder = locale['goals_details']['search_cost_centers'];


return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(props.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(AtomInputSearch), {
        classes: "",
        prependIcon: "",
        noBgPrependIcon: "",
        noBorderPrependIcon: "",
        placeholder: _unref(placeholder),
        modelValue: search.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
        width: "250px"
      }, {
        prependIcon: _withCtx(() => [
          _createVNode(_unref(SearchStatusIcon))
        ]),
        _: 1
      }, 8, ["placeholder", "modelValue"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsComputed.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "py-0 item-search",
          key: String(index)
        }, [
          _createVNode(_unref(AtomInput), {
            disabled: "",
            prependIcon: "",
            noBgPrependIcon: "",
            noBorderPrependIcon: "",
            placeholder: item.name,
            "model-value": item.name
          }, {
            prependIcon: _withCtx(() => [
              (_ctx.type == 'brand')
                ? (_openBlock(), _createBlock(_component_v_avatar, {
                    key: 0,
                    color: "grey",
                    size: "24",
                    rounded: "0",
                    style: {"border-radius":"15% !important"}
                  }, {
                    default: _withCtx(() => [
                      (item.image?.includes('http'))
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            style: {"height":"100%","width":"100%"},
                            src: `${item.image ?? ''}`,
                            crossorigin: "anonymous"
                          }, null, 8, _hoisted_3))
                        : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString((item.image ?? '').toUpperCase()), 1))
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              (_ctx.type == 'reseale')
                ? (_openBlock(), _createBlock(_unref(ResealeIcon), { key: 1 }))
                : _createCommentVNode("", true),
              (_ctx.type == 'warehouse')
                ? (_openBlock(), _createBlock(_unref(WarehouseIcon), { key: 2 }))
                : _createCommentVNode("", true),
              (_ctx.type == 'cost_center')
                ? (_openBlock(), _createBlock(_unref(CostCenterIcon), { key: 3 }))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["placeholder", "model-value"])
        ]))
      }), 128))
    ])
  ], 64))
}
}

})